import { CloseIcon } from '@diligentcorp/atlas-react-icons';
import {
  useAtlasCoreThemeTokens,
  useAtlasSemanticThemeTokens,
} from '@issuemanager/apps/client/theme';
import {
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import React, { ReactNode } from 'react';
import { GeneralErrorUI } from '../errors/generalError';

type Props = React.PropsWithChildren & {
  onClose: (bool: boolean) => void;
  open: boolean;
  title: string;
  footer: ReactNode;
  error?: boolean;
};

const StyledIconButton = styled(IconButton)<{ iconColor: string }>(
  ({ iconColor }) => ({
    color: iconColor,
  }),
);

const StyledDrawer = styled(Drawer)`
  .MuiDrawer-paperAnchorRight {
    background-color: white;
    border-right: 0;
  }
`;

const StyledDivider = styled(Divider)`
  height: 2px;
  background: ${({ color }) => color};
`;

type StyledStackSectionProps = {
  pr?: number;
};
const StyledStackSection = styled(Stack)<StyledStackSectionProps>`
  padding: ${({ pr, theme }) =>
    `${theme.spacing(2)} ${pr ? `${pr}px` : theme.spacing(2)} ${theme.spacing(
      2,
    )} ${theme.spacing(3)}`};
`;

export function SidePanel(props: Props) {
  const { onClose, open, title, footer, children, error } = props;
  const semantic = useAtlasSemanticThemeTokens();
  const core = useAtlasCoreThemeTokens();

  return (
    <StyledDrawer
      anchor='right'
      variant='temporary'
      open={open}
      onClose={(_, _reason) => onClose(false)}
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: 'transparent',
          },
        },
      }}
    >
      <Stack width={480} height='100%' border={1}>
        {error ? (
          <GeneralErrorUI />
        ) : (
          <>
            <StyledStackSection
              flexDirection='row'
              justifyContent='space-between'
              alignItems='center'
            >
              <Typography variant='h3' fontWeight={600}>
                {title}
              </Typography>
              <StyledIconButton
                onClick={() => onClose(false)}
                iconColor={core.color.legacy.blackNear.value}
              >
                <CloseIcon />
              </StyledIconButton>
            </StyledStackSection>
            <StyledDivider color={semantic.color.background.selected.value} />
            <StyledStackSection pr={40} overflow='scroll' flexGrow={2}>
              {children}
            </StyledStackSection>
            <StyledDivider color={semantic.color.background.selected.value} />
            <StyledStackSection flexDirection='row' justifyContent='flex-end'>
              {footer}
            </StyledStackSection>
          </>
        )}
      </Stack>
    </StyledDrawer>
  );
}
